import { Autocomplete, TextField } from "@mui/material";
import React, { ChangeEvent, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { Button, Typography } from "@mui/material";
import "./ProductModal.css";
import {
  brandType,
  categoryType,
  productImageType,
  productMetaData,
  productModelData,
  productModelDataDetails,
} from "./ProductModalTypes";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

const ProductDetails = ({
  submit: { check, setCheck },
  additionalCachedData,
  defaultInputs: { defaultInputs, setDefaultInputs },
  requestBody: { editRequestBody, setEditRequestBody },
  disableEdit 
}: productModelDataDetails) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT = "ProductDetails"
  return (
    <div className="model-child">
      <TextField
        label= {translate(TranslationEnum.product_details,"sku_code")}
        id="outlined-start-adornment"
        value={defaultInputs.skuCode}
        disabled={true}
      />
      <TextField
       disabled={disableEdit} 
        label={translate(TranslationEnum.product_details,"skuname")}
        id="outlined-start-adornment"
        value = {defaultInputs.skuName}
        onChange={(event) => {
          setDefaultInputs((prev: productMetaData) => ({
            ...prev,
            "skuName" : event.target.value
          }));
          setEditRequestBody((prev: productMetaData) => ({
            ...prev,
            skuName: event.target.value,
          }));
          setCheck(true);
        }}
      />
      <Autocomplete
       disabled={disableEdit} 
        disablePortal
        options={additionalCachedData[0].map(({brand}: brandType) => {
          return brand;
        })}
        
        value ={defaultInputs.brand}
        onChange={(event, value: string | null) => {
          if(value){
          setDefaultInputs((prev: productMetaData) => ({
            ...prev,
            "brand":value
          }));
          setEditRequestBody((prev: productMetaData) => ({
            ...prev,
            brand: value,
          }));
          setCheck(true);
        }}
      }
        sx={{ width: "100%" }}
        renderInput={(params) => <TextField {...params} label= {translate(TranslationEnum.product_details,"Brand" )}/>}
      />
      <Autocomplete
       disabled={disableEdit} 
        disablePortal
        options={additionalCachedData[1].map(({category}: categoryType) => {
          return category;
        })}
        value = {defaultInputs.category}
        sx={{ width: "100%" }}
        renderInput={(params) => <TextField {...params} label= {translate(TranslationEnum.product_details,"Category" )}/>}
        onChange={(event, value: string | null) => {
          if(value){
          setDefaultInputs((prev: productMetaData) => ({
            ...prev,
            "category":value,
          }));
          setEditRequestBody((prev: productMetaData) => ({
            ...prev,
            category: value,
          }));
          setCheck(true);
        }}
      }
      />
    </div>
  );
};

const UomMapping = ({
  submit: { check, setCheck },
  defaultInputs: { defaultInputs, setDefaultInputs },
  requestBody: { editRequestBody, setEditRequestBody },
  disableEdit 
}: productModelData) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT = "ProductDetails"
  return (
    <div className="model-child">
      <TextField
        disabled={disableEdit} 
        label={translate(TranslationEnum.product_details,"no_of_pieces_in_case" )}
        id="outlined-start-adornment"
        value={defaultInputs.caseToPieceQuantity}
        onChange={(event) => {
          setDefaultInputs((prev: productMetaData) => ({
            ...prev,
            "caseToPieceQuantity":event.target.value,
          }));
          setEditRequestBody((prev: productMetaData) => ({
            ...prev,
            caseToPieceQuantity: event.target.value,
          }));
          setCheck(true);
        }}
      />
      <TextField
        disabled={disableEdit} 
        label={translate(TranslationEnum.product_details,"no_of_pieces_in_outer" )}
        id="outlined-start-adornment"
        value={defaultInputs.otherUnitToPieceQuantity}
        onChange={(event) => {
          setDefaultInputs((prev: productMetaData) => ({
            ...prev,
            "otherUnitToPieceQuantity":event.target.value,
          }));
          setEditRequestBody((prev: productMetaData) => ({
            ...prev,
            otherUnitToPieceQuantity: event.target.value,
          }));
          setCheck(true);
        }}
      />
    </div>
  );
};

const ProductPricing = ({
  submit: { check, setCheck },
  defaultInputs: { defaultInputs, setDefaultInputs },
  requestBody: { editRequestBody, setEditRequestBody },
}: productModelData) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT = "ProductDetails"
  return (
    <div className="model-child">
      <div className="model-select">
        <TextField
          sx={{ width: "49%" }}
          label={translate(TranslationEnum.product_details,"mrp" )}
          id="outlined-start-adornment"
          value={defaultInputs.mrp}
          disabled={true}
        />
        <TextField
          sx={{ width: "49%" }}
          label={translate(TranslationEnum.product_details,"outer_mrp" )}
          id="outlined-start-adornment"
          disabled={true}
        />
      </div>
      <div className="model-select">
        <TextField
          sx={{ width: "49%" }}
          label={translate(TranslationEnum.product_details,"carton_mrp" )}
          id="outlined-start-adornment"
          disabled={true}
        />
        <TextField
          sx={{ width: "49%" }}
          label={translate(TranslationEnum.product_details,"each_price" )}
          id="outlined-start-adornment"
          disabled={true}
        />
      </div>

      <div className="model-select">
        <TextField
          sx={{ width: "49%" }}
          label={translate(TranslationEnum.product_details,"outer_price" )}
          id="outlined-start-adornment"
          disabled={true}
        />
        <TextField
          sx={{ width: "49%" }}
          label={translate(TranslationEnum.product_details,"carton_price" )}
          id="outlined-start-adornment"
          disabled={true}
        />
      </div>
    </div>
  );
};

const ProductImage = ({
  resolution: { height, width },
  elementState:{element,setElement},
  submit: { check, setCheck }
}: productImageType) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT = "ProductDetails"
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File | null>(null);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const handleImageUpload = () => {
    fileInputRef.current?.click();
  };
  const validateImageAndUpload = (file: File) => {
    if (file) {
      let fileType = file.type.split("/")[0];
      let fileExtension = file.type.split("/")[1];
      if (fileType === "image") {
        if (["png", "jpeg", "jpg"].includes(fileExtension)) {
          let img = new Image();
          let objectUrl = URL.createObjectURL(file);
          img.onload = function (evt) {
            if (img.naturalHeight !== height || img.naturalWidth !== width) {
              setErrorMessage(
                translate(TranslationEnum.product_details, "image resolution must be {width}X{height}",{"width":width.toString(),"height":height.toString()})
              );
              setFile(null);
            } else {
              setErrorMessage("");
              setFile(file);
              setElement({inputRef: fileInputRef.current});
              setCheck(true);
            }
          };
          img.src = objectUrl;
        } else {
          setErrorMessage("Image must be png,jpeg or jpg");
          setFile(null);
        }
      } else {
        setErrorMessage("Please choose a image");
        setFile(null);
      }
    }
  };
  const handleUpload = (event:ChangeEvent<HTMLInputElement>) => {
    if(event.target.files && event.target.files.length>0) validateImageAndUpload(event.target.files[0]);
  };
  const handleReset = () => {
    if (fileInputRef.current !== null) {
      fileInputRef.current.value = "";
      setFile(null);
    }
    setElement({});
    setCheck(true)
  };
  return (
    <div className="inputsContainer imageInputsContainer">
      <div className="imageUpload" onClick={handleImageUpload}>
        {file? (
          <>
            <img
              className="product-image"
              src={URL.createObjectURL(file)}
              height="60"
              width="auto"
              alt="productImage"
            />
            <Typography variant="subtitle1">
              {file.name}
            </Typography>
          </>
        ) : element.blobKey ? (
          <>
            <img
              className="product-image"
              src={element.blobKey}
              height="60"
              width="auto"
              alt="productImage"
            />
            <Typography variant="subtitle1">{element.fileName}</Typography>
          </>
        ) : (
          <>
            <FontAwesomeIcon fontSize="45px" icon={faCamera} />
            <Typography variant="subtitle1">
            {translate(TranslationEnum.common_portal,"Upload Image" )} ({width}*{height})
            </Typography>
          </>
        )}
        <input type="file" onChange={handleUpload} hidden ref={fileInputRef} />
      </div>
      {errorMessage ? (
        <Typography variant="subtitle1" color="red">
          {translate(TranslationEnum.common_portal,errorMessage )}
        </Typography>
      ) : (
        <></>
      )}
      <Button
        onClick={()=>{
          if(element?.inputRef?.files?.[0] || element.blobKey){
            handleReset()
          }
        }}
        style={{
          padding: "0.5rem 1.6rem",
          fontSize: "0.64rem",
          backgroundColor: "#00C6B1",
          marginTop: "15px",
        }}
        variant="contained"
      >
        {translate(TranslationEnum.common_portal,"RESET" )}
      </Button>
    </div>
  );
};

export { ProductDetails, UomMapping, ProductPricing, ProductImage };
